/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Api_Baglantisi_NasilInputs */

const tr_faq_q_api_baglantisi_nasil = /** @type {(inputs: Faq_Q_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri API bağlantısı nasıl alınır?`)
};

const en_faq_q_api_baglantisi_nasil = /** @type {(inputs: Faq_Q_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do I get my API keys?`)
};

const de_faq_q_api_baglantisi_nasil = /** @type {(inputs: Faq_Q_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo bekomme ich die API-Schlüssel?`)
};

const ru_faq_q_api_baglantisi_nasil = /** @type {(inputs: Faq_Q_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Где получить API-ключи?`)
};

/**
* | output |
* | --- |
* | "Where do I get my API keys?" |
*
* @param {Faq_Q_Api_Baglantisi_NasilInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_api_baglantisi_nasil = /** @type {((inputs?: Faq_Q_Api_Baglantisi_NasilInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Api_Baglantisi_NasilInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_api_baglantisi_nasil(inputs)
	if (locale === "de") return de_faq_q_api_baglantisi_nasil(inputs)
	if (locale === "ru") return ru_faq_q_api_baglantisi_nasil(inputs)
	return tr_faq_q_api_baglantisi_nasil(inputs)
});